import { Quill  } from "vue2-editor"
let BlockEmbed = Quill.import('blots/block/embed');

class VideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create()

    let newNode = document.createElement('div')
    newNode.setAttribute('class', 'embed-responsive embed-responsive-16by9')

    // Set non-format related attributes with static values
    node.setAttribute('frameborder', '0')
    node.setAttribute('allowfullscreen', true)
    node.setAttribute('src', url)
    node.setAttribute('class', 'embed-responsive-item')

    newNode.appendChild(node)

    return newNode
  }

  static formats(node) {
    // We still need to report unregistered embed formats
    let format = {};
    if (node.hasAttribute('height')) {
      format.height = node.getAttribute('height')
    }
    if (node.hasAttribute('width')) {
      format.width = node.getAttribute('width')
    }
    return format
  }

  static value(node) {
    return node.getAttribute('src')
  }

  format(name, value) {
    // Handle unregistered embed formats
    if (name === 'height' || name === 'width') {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name, value)
      }
    } else {
      super.format(name, value)
    }
  }
}
VideoBlot.blotName = 'video'
VideoBlot.tagName = 'iframe'

export default VideoBlot
